import $ from 'jquery';

const modal = () => {
  const modalOpen = $('.js-modal-open');
  modalOpen.on('click', ev => {
    ev.preventDefault();
    const self = ev.currentTarget;
    const target = self.getAttribute('data-modal');
    const emailField = $(ev.target).siblings();
    const modalEl = $(target);
    if (modalEl.length) {
      modalEl.find('.ginput_container_email input').val(emailField.val());
      modalEl.fadeIn();
    }
  });

  const modalClose = $('.js-modal-close');
  if (modalClose.length) {
    modalClose.on('click', ev => {
      ev.preventDefault();
      const self = $(ev.target);
      const parentModal = self.closest('.o-modal');
      if (parentModal.length) {
        parentModal.fadeOut();
      }
    });
  }
};
export default modal;



// WEBPACK FOOTER //
// ./src/scripts/modules/modal.js